import { updateArrayItem } from '@/util/array';
import airportsService from '@/api/airports-service';
import eventBus, { OPEN_SNACKBAR } from '@/util/event-bus';
import i18n from '@/i18n/i18n-config';
import { mapErrorsToInputs } from '@/util/forms';

export const initialAirportsFilterParams = () => ({
  name: '',
  airport_id: null,
  location: null
});

const state = {
  airports: null,
  airportsPagination: {},
  editedAirport: {},
  airportValidationErrors: {},
  airportsFilterParams: initialAirportsFilterParams(),
};

const getters = {
  airportsMap(state) {
    const map = {};

    if (!state.airports) {
      return {};
    }

    for (let i = 0; i < state.airports?.length; i++) {
      map[state.airports[i].id] = state.airports[i];
    }
    return map;
  },
};

const mutations = {
  SET_AIRPORTS(state, { data, current_page, per_page, total }) {
    state.airports = data;
    state.airportsPagination = {
      current_page,
      per_page,
      total,
    };
  },

  SET_FILTER_PARAMS(state, params) {
    state.airportsFilterParams = params;
  },

  SET_EDITED_AIRPORT(state, airport) {
    state.airportValidationErrors = {};
    state.editedAirport = JSON.parse(JSON.stringify(airport));
  },

  UPDATE_AIRPORT(state, airport) {
    state.airports = updateArrayItem(state.airports, airport);
  },

  SET_AIRPORT_VALIDATION_ERRORS(state, validationErrors) {
    state.airportValidationErrors = validationErrors;
  },

  CLEAR_VALIDATION_ERRORS(state, field) {
    delete state.airportValidationErrors[field];
  },
};

const actions = {
  fetchAirports({ state, commit }, params = {}) {
    commit('SET_FILTER_PARAMS', params);
    return airportsService.getPage(params).then((res) => {
      commit('SET_AIRPORTS', res.data);
      if (params.page !== state.airportsFilterParams.page) {
        window.scrollTo(0, 0);
      }
    });
  },

  editAirport({ state, commit }, airportId) {
    const airport = state.airports?.find((a) => a.id === airportId);
    if (airport) {
      commit('SET_EDITED_AIRPORT', airport);
      return Promise.resolve(airport);
    }
    return airportsService.getById(airportId).then((res) => {
      commit('SET_EDITED_AIRPORT', res.data);
      return res.data;
    });
  },

  updateAirport({ commit }, airport) {
    return airportsService
      .update(airport)
      .then((res) => {
        commit('UPDATE_AIRPORT', res.data);
        eventBus.$emit(OPEN_SNACKBAR, i18n.t('airport_updated'));
      })
      .catch((err) => {
        commit('SET_AIRPORT_VALIDATION_ERRORS', mapErrorsToInputs(err));
        throw err;
      });
  },

  clearAirportValidationErrors({ commit }, field) {
    commit('CLEAR_VALIDATION_ERRORS', field);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
